interface CardData {
  iconSrc: string;
  iconAlt: string;
  title: string;
  points: string[];
}

const CARDS: CardData[] = [
  {
    iconSrc: 'https://files.catbox.moe/bmphn6.svg',
    iconAlt: '元看護師アドバイザー',
    title: '元看護師アドバイザーによる親身サポート',
    points: [
      '現場を知る女性アドバイザーが転職活動をフルサポート',
      'キャリア相談から面接対策・条件交渉まで、あなたに合わせたアドバイスが可能',
      '「ブランクがあって不安...」「職場の雰囲気を知りたい」など、看護師の現場を熟知しているからこそ安心して任せられます',
    ],
  },
  {
    iconSrc: 'https://files.catbox.moe/9aozrr.svg',
    iconAlt: 'LINEで無料相談',
    title: 'LINEで気軽に相談 完全無料',
    points: [
      '登録や利用に費用は一切かかりません',
      'LINE相談OKで、勤務の合間や自宅でも手軽に情報交換可能',
      '電話対応が難しい方でもチャットでスムーズに進められるので、忙しい現場でもストレスフリー',
    ],
  },
  {
    iconSrc: 'https://files.catbox.moe/clxmql.svg',
    iconAlt: '徹底サポート',
    title: '希望の転職先が見つかるまで、徹底的にサポート！',
    points: [
      '理想の転職先が見つからない場合も、私たちが徹底的にリサーチ・直接交渉し、あなただけの求人を見つけます',
      '病院・クリニック・介護施設・企業など、さまざまな働き方に応じた転職先を紹介',
      '非公開の高待遇求人も多数紹介ができます',
    ],
  },
];

export default function ReasonSection() {
  return (
    <section
      data-track-view="view_reason_section"
      data-element-name="reason_section"
      style={{ padding: '48px 16px', background: '#fff' }}
    >
      <div style={{ maxWidth: '480px', margin: '0 auto' }}>
        {/* Section Title */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <h2
            style={{
              fontFamily: "'Zen Maru Gothic', sans-serif",
              fontWeight: 900,
              fontSize: '24px',
              color: '#333',
              lineHeight: 1.4,
              marginBottom: '10px',
            }}
          >
            ニジ看護転職が
            <br />
            <span style={{ color: '#fa7c9e' }}>選ばれる理由</span>
          </h2>
          <div style={{ width: '48px', height: '4px', background: '#fa7c9e', borderRadius: '2px', margin: '0 auto' }} />
        </div>

        {/* Cards — SP縦積み固定 */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {CARDS.map((card, i) => (
            <div
              key={i}
              data-track-view="view_reason"
              data-element-type="reason_card"
              data-element-name={card.iconAlt}
              data-element-index={i}
              style={{
                background: 'white',
                borderRadius: '8px',
                padding: '20px 16px',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                border: '1px solid #ffe0e8',
              }}
            >
              {/* Card Header */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '14px' }}>
                <div style={{ width: '56px', height: '56px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img src={card.iconSrc} alt={card.iconAlt} width={56} height={56} />
                </div>
                <h3 style={{ fontWeight: 700, fontSize: '15px', color: '#333', lineHeight: 1.4 }}>
                  {card.title}
                </h3>
              </div>

              {/* Points */}
              <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {card.points.map((point, j) => (
                  <li key={j} style={{ display: 'flex', gap: '8px', alignItems: 'flex-start', fontSize: '13px', color: '#555', lineHeight: 1.7 }}>
                    <span style={{ color: '#fa7c9e', fontWeight: 700, flexShrink: 0 }}>✓</span>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
